import React, { Component } from 'react';

// Materia UI
import { InputGroup, FormControl } from 'react-bootstrap';
import { withStyles } from '@material-ui/core/styles';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import clsx from 'clsx';

// Components and Others
import PropTypes from 'prop-types';

const styles = () => ({
    button: {
        '& :hover': {
            backgroundColor: '#e3e6ea',
            borderColor: '#dce0e4',
            color: '#777777',
            transition: 'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
        },
        '& :active': {
            backgroundColor: '#e3e6ea',
            borderColor: '#dce0e4',
            color: '#777777',
            opacity: '0.7',
            transition: 'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
        },
    },
    white: {
        backgroundColor: '#FFFFFF',
        transition: '0.15s',
    },
});

class InputWithButton extends Component {
    render() {
        const {
            props: {
                classes,
                onClick,
                value,
                size,
                icon: IconComponent,
            },
        } = this;
        const inputGroupTextProps = { };

        if (size === 'sm') {
            inputGroupTextProps.style = { paddingTop: '0px', paddingBottom: '0px' };
        }

        const RenderIcon = IconComponent || MoreHorizIcon;

        return (
            <InputGroup className={clsx(classes.input, (size ? `input-group-${size}` : null))}>
                <FormControl
                    disabled
                    value={value}
                    size={size}
                />
                <InputGroup.Append onClick={onClick} className={classes.button}>
                    <InputGroup.Text className={classes.white} {...inputGroupTextProps}>
                        <RenderIcon fontSize={size === 'sm' ? 'small' : 'default'} />
                    </InputGroup.Text>
                </InputGroup.Append>
            </InputGroup>
        );
    }
}

InputWithButton.propTypes = {
    onClick: PropTypes.func,
    size: PropTypes.string,
    classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    icon: PropTypes.elementType,
};

InputWithButton.defaultProps = {
    onClick: () => {},
    value: '',
    size: 'md',
    icon: null,
};

export default withStyles(styles)(InputWithButton);
